import { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Card,
  Space,
  Table,
  Divider,
  Select,
  Tooltip,
  Button
} from "antd";
import { ArrowLeftOutlined } from '@ant-design/icons';
import useWindowSize from "../../../Shared/Utils/windowResizeUtils";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { useNavigate } from "react-router-dom";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import EmbedReports from "../EmbedReports/EmbedReports";

const Reports = ({ workspace_list, defaultValue }) => {
  const [reportList, setReportList] = useState({
    tableData: {
      headerContent: [],
      bodyContent: [],
    },
  });
  const [selectedWorkspace, setSelectedWorkspace] = useState(defaultValue);
  const [currentReportIndex, setCurrentReportIndex] = useState();
  const [expanded, setExpanded] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const [embeddedData, setEmbeddedData] = useState({});

  const { width } = useWindowSize();
  const isMobile = width <= 768;
  const navigate = useNavigate();

  useEffect(() => {
    getAttendee(selectedWorkspace);
  }, [selectedWorkspace]);

  const getAttendee = (workspace_id) => {
    let payload = {
      workspace_id: workspace_id,
    };
    ServiceUtils.postRequest("reports", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          response.data.tableData?.headerContent.map((el) => {
            if (el.key === "reportName") {
              el.render = (_, record) => (
                <Space size="middle">
                  <a onClick={() => onReportSelect(record)}>
                    {record?.reportName}
                  </a>
                </Space>
              );
            } else if (el.key === "description") {
              el.render = (_, record) => (
                <Tooltip title={record?.description}>
                  <Space size="middle">{record?.description}</Space>
                </Tooltip>
              );
            }
          });
          setReportList(response.data);
        } else if (response.status === 401) {
          navigate("/logout");
        }
      },
      (error) => {
        alertService.error("Error while fetching data.");
      }
    );
  };

  const onReportSelect = (record) => {
    const data = {
      embedUrl: record?.url,
      repordId: record?.report_id,
      token: record?.token,
    };
    if (selectedWorkspace === "general") {
      setShowReports(false);
      window.open(record?.url);
    } else {
      setEmbeddedData(data)
      setShowReports(true);
    }
  };

  const setCurrentStateReport = (ind, value) => {
    setCurrentReportIndex(ind);
    setExpanded(value);
  };

  const handleWorkSpace = (val, data) => {
    const { value, label } = data;
    setSelectedWorkspace(value);
  };

  const goBack = () => {
    setShowReports(false);
    setSelectedWorkspace("general");
  }

  return showReports ? (
    <>
    <div style={{padding:"5px"}}>
    <Button type="primary" onClick={goBack}><ArrowLeftOutlined />Back</Button>
    </div>
     <EmbedReports {...embeddedData} />
    </>
  ) : (
    <div className="reports">
      <div style={{ padding: "0 30px" }}>
        <div className="cls-reports">
          {isMobile ? (
            <>
              <div
                style={{ padding: "5px", marginBottom: "20px" }}
                className="report-mobile-card"
              >
                <Row gutter={[10, 10]}>
                  {reportList?.tableData?.bodyContent.map((item, index) => (
                    <Col xs={24} sm={12} md={8} key={item.slNo}>
                      <Card
                        title={
                          <div>
                            <a
                              style={{
                                color: "#235D9F",
                                fontWeight: "400",
                                padding: "0 15px",
                              }}
                              onClick={() => onReportSelect(item)}
                            >
                              {item?.reportName}
                            </a>
                          </div>
                        }
                        style={{ border: "0.5px solid #EAEAEA" }}
                        styles={{
                          body: { padding: "0 10px 10px 10px" },
                          head: { borderBottom: "1px solid #EAEAEA" },
                        }}
                        bordered={false}
                      >
                        <Divider
                          style={{
                            margin: "0 0 5px 0",
                            borderWidth: "2px",
                          }}
                        />
                        <Row gutter={[16, 16]}>
                          <Col xs={7} sm={7} md={7}>
                            <p style={{ margin: 0, color: "#5D6063" }}>
                              Description&nbsp;{" "}
                            </p>
                          </Col>
                          <Col xs={17} sm={17} md={17}>
                            <Typography.Paragraph
                              style={{
                                fontWeight: "500",
                                marginBottom: 0,
                              }}
                              ellipsis={{
                                rows: 2,
                                expandable: "collapsible",
                                expanded:
                                  index === Number(currentReportIndex) &&
                                  expanded
                                    ? true
                                    : false,
                                onExpand: (_, info) =>
                                  setCurrentStateReport(index, info.expanded),
                                symbol:
                                  index === Number(currentReportIndex) &&
                                  expanded ? (
                                    <>See less</>
                                  ) : (
                                    <>See more</>
                                  ),
                              }}
                            >
                              {item.description}
                            </Typography.Paragraph>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  marginBottom: "5px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Select
                  defaultValue={defaultValue}
                  style={{ width: 180 }}
                  onChange={handleWorkSpace}
                  options={workspace_list}
                />
              </div>
              <div className="reports-table">
                <Table
                  pagination={false}
                  columns={reportList.tableData.headerContent}
                  dataSource={reportList.tableData.bodyContent}
                  bordered
                  scroll={{
                    y: "calc(100vh - 270px)",
                  }}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Reports;
